if (window.toggleBurgerMenu === undefined) {
  window.toggleBurgerMenu = true;

  const overlay = document.getElementById('open-burger-menu');
  const panel = document.getElementById('burger-menu-panel');
  const closeButton = document.getElementById('close-burger-menu');
  const openers = Array.from(document.querySelectorAll('[data-burger-open]'));
  const desktop = window.matchMedia('(min-width: 1024px)');

  let isOpen = false;
  let inerted = [];

  // Inerting the siblings is what makes the panel modal: focus and the accessibility
  // tree are both confined to it, without a hand-rolled focus trap.
  const setOutsideInert = () => {
    for (const element of inerted) element.inert = false;
    inerted = [];

    if (!isOpen) return;

    for (const element of document.body.children) {
      if (element === overlay || element.inert) continue;

      element.inert = true;
      inerted.push(element);
    }
  };

  const render = ({ moveFocus }) => {
    overlay.style.right = isOpen ? '0' : '-100%';
    document.body.style.overflow = isOpen ? 'hidden' : '';
    // The closed panel stays laid out off-screen: `inert` keeps it out of the tab order.
    panel.inert = !isOpen;
    setOutsideInert();

    for (const opener of openers) {
      opener.setAttribute('aria-expanded', String(isOpen));
    }

    if (moveFocus) {
      (isOpen ? closeButton : openers[0])?.focus({ preventScroll: true });
    }
  };

  const setOpen = (open, { moveFocus = true } = {}) => {
    if (isOpen === open) return;

    isOpen = open;
    render({ moveFocus });
  };

  for (const opener of openers) {
    opener.addEventListener('click', () => setOpen(true));
  }

  closeButton?.addEventListener('click', () => setOpen(false));

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') setOpen(false);
  });

  // The desktop nav comes back on its own, so an open panel would duplicate it. The
  // burger opener is hidden at that width, so the focus goes to the desktop nav instead
  // of staying in the panel we are about to inert.
  desktop.addEventListener('change', () => {
    if (!desktop.matches) return;

    const held = overlay.contains(document.activeElement);

    setOpen(false, { moveFocus: false });

    if (held) {
      document
        .querySelector('#header .js-dropdown-button')
        ?.focus({ preventScroll: true });
    }
  });
}
